import { render } from "./SelectRole.vue?vue&type=template&id=52136178&scoped=true"
import script from "./SelectRole.vue?vue&type=script&lang=js"
export * from "./SelectRole.vue?vue&type=script&lang=js"

import "./SelectRole.vue?vue&type=style&index=0&id=52136178&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52136178"]])

export default __exports__